module.exports = "<div class=\"image\" [ngStyle]=\"{'background-image': 'url(' + image.url + ')'}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/image/image.component.html
// module id = 223
// module chunks = 1